var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fecb00;}.cls-2{fill:#d08b00;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#db9300;}.cls-4{fill:#b17600;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "indian-rupee-coin-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.44,8.74a52.69,52.69,0,0,1,52.7,52.7c0,.31,0,.61,0,.92a50.86,50.86,0,1,0-51.77,51.77h-.92a52.7,52.7,0,0,1,0-105.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.28,12.41A50.87,50.87,0,1,1,12.41,63.28,50.87,50.87,0,0,1,63.28,12.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.31,58.09l3.78-8.68H60.34a5.55,5.55,0,0,0-.94-1.82,7,7,0,0,0-1.66-1.54,9.19,9.19,0,0,0-2.21-1A7.88,7.88,0,0,0,53,44.59H42.31l3.78-8.69h40.8l-3.78,8.69H73.25a6.87,6.87,0,0,1,1.09,1.07,8.56,8.56,0,0,1,.89,1.25,13,13,0,0,1,.64,1.3,5.38,5.38,0,0,1,.34,1.2H86.89l-3.78,8.68H75.38a14.09,14.09,0,0,1-2.53,4.19A20.71,20.71,0,0,1,69,65.83a25.24,25.24,0,0,1-4.85,2.65,23.16,23.16,0,0,1-5.31,1.45L80.23,92.44h-17L44.17,71v-8h8.46a7.13,7.13,0,0,0,2.4-.41,9,9,0,0,0,2.19-1.1A8.24,8.24,0,0,0,59,60a5.84,5.84,0,0,0,1-1.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.67,55.86l3.78-8.51H57.7a5.38,5.38,0,0,0-.94-1.78,6.56,6.56,0,0,0-1.67-1.51,8.93,8.93,0,0,0-2.2-1,8.14,8.14,0,0,0-2.58-.39H39.67l3.78-8.52h40.8l-3.78,8.52H70.61a6.65,6.65,0,0,1,1.09,1,9,9,0,0,1,.89,1.23,12.59,12.59,0,0,1,.64,1.27,6,6,0,0,1,.34,1.18H84.25l-3.78,8.51H72.74A14.24,14.24,0,0,1,70.21,60a20.48,20.48,0,0,1-3.91,3.48A24.76,24.76,0,0,1,61.45,66a23.51,23.51,0,0,1-5.3,1.42L77.59,89.53h-17l-19.12-21V60.74H50a7.37,7.37,0,0,0,2.4-.4,9.33,9.33,0,0,0,2.19-1.09,8.11,8.11,0,0,0,1.74-1.55,5.42,5.42,0,0,0,1-1.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.9f51527f90e9676070618580a1738dbd.svg";
export { ForwardRef as ReactComponent };